import { EuiFlexGroup,EuiFlexItem,EuiFieldSearch,EuiPanel } from '@elastic/eui';
import { useState, useEffect, useMemo} from 'react';
import { Sumarigrama } from '../../../../../../infraestructure/persistence/rest/SumarigramaAdapter';
import SelectorVersionesGiasContainer from '../../../../components/Selectores/VersionesGias/container';
import { SumarigramaTreeView } from './sumarigrama';
import './styles.css';

import { Action } from '../../../../components/Menus/interface';
import { Menu } from '../../../../components/Menus';

interface dataRequest {IdVersion:number, IdInicial:string}

interface Props {
  data: Sumarigrama;
  handleFilter(version?: number): void;
  menu: boolean;
  onlySearch: boolean;
  onClickNode?(id: number): void;
  style?: any;   
  onExport?(data: dataRequest): void;
}

export const SumarigramaScreen = (props: Props) => {
  const { menu, onlySearch, data, handleFilter, onClickNode, style, onExport} = props;

  let [version, setVersion] = useState(undefined);
  let [search, setSearch] = useState(undefined);
  let [idCentro, setIdCentro] = useState<any>(undefined);

  const onChangeVersion = (value:any) =>{
    setVersion(value)
  }

  const onChangeSearch = (value:any) =>{ 
    if(value!=='')
      setSearch(value.toString())
    else
      setSearch(undefined)
  }

  const onExportar = () =>{
    // ref.current && ref.current.onExport();
    console.log('export Excel' + idCentro);
    onExport && onExport({IdVersion: version ?? 0, IdInicial: idCentro})
  }

  const onClickCentro = (id:number)=> {
    onClickNode && onClickNode(id);
    setIdCentro(id);
  }

  const Actions: Action[] = useMemo(()=> [
    {handle:onExportar,text:"Exportar",size:"s", isDisabled:false}
  ],[idCentro, version])

    
  useEffect(() =>{
    version && handleFilter(version)
  },[version])

  return (
    <>
    <EuiFlexGroup direction='column' gutterSize='s' style={{height:'100%'}}>
      {menu?
      <EuiFlexItem grow={false}>
          {/* <EuiPanel paddingSize="m" hasShadow={false} borderRadius="none" color="transparent" 
          style={{borderTop:'none',borderRight:'none', borderLeft:'none', borderBottom:'1px solid #D3DAE6', position: 'sticky', top: 0, background: '#ffffff', zIndex: 999}}> */}
            <EuiFlexGroup>
              {onlySearch? null :
              <EuiFlexItem grow={false}> 
                <SelectorVersionesGiasContainer valueOfSelected={version} onChange={(e:any)=>{onChangeVersion(e)}}/>
              </EuiFlexItem> 
              }
              <EuiFlexItem grow={false}> 
                <EuiFieldSearch placeholder="Buscar Centro ..." onSearch={onChangeSearch} />
              </EuiFlexItem>
            </EuiFlexGroup>
          {/* </EuiPanel> */}
          {onlySearch? null :
              <EuiFlexItem grow={false}> 
                <Menu actions={Actions}/>
              </EuiFlexItem> 
              }
        </EuiFlexItem>
        :null}
      <EuiFlexItem grow={false} style={{overflow:'auto'}}>
        <EuiPanel paddingSize="m" color="transparent" style={style}>
          <SumarigramaTreeView data={data} search={search} version={version} onClickNode={onClickCentro} style={{height:'100%'}}/>
        </EuiPanel>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
  );
};

export default SumarigramaScreen;
